import type { CareerLevel } from '../flags/types';

export type { CareerLevel };

export interface LevelMeta {
  level: CareerLevel;
  index: number;
  title: string;
  subtitle: string;
  baseThreshold: number; // cash needed in one round to be promoted
  accentColor: number;   // hex used for promotion overlay accent
}

export const careerLevels: CareerLevel[] = ['admin', 'paralegal', 'attorney', 'partner'];

export const levelMeta: Record<CareerLevel, LevelMeta> = {
  admin: {
    level: 'admin',
    index: 0,
    title: 'Office Admin',
    subtitle: 'Filing, scheduling, mail, the front desk.',
    baseThreshold: 500,
    accentColor: 0xfb923c
  },
  paralegal: {
    level: 'paralegal',
    index: 1,
    title: 'Paralegal',
    subtitle: 'Research, motions, discovery, e-filing.',
    baseThreshold: 1500,
    accentColor: 0x818cf8
  },
  attorney: {
    level: 'attorney',
    index: 2,
    title: 'Attorney',
    subtitle: 'Memos, depositions, motion hearings, deals.',
    baseThreshold: 4000,
    accentColor: 0xa78bfa
  },
  partner: {
    level: 'partner',
    index: 3,
    title: 'Partner',
    subtitle: 'Pitch, trial, major deals, originate.',
    baseThreshold: Number.POSITIVE_INFINITY, // top of the ladder
    accentColor: 0xfbbf24
  }
};

export function nextLevel(level: CareerLevel): CareerLevel | null {
  const i = careerLevels.indexOf(level);
  if (i < 0 || i >= careerLevels.length - 1) return null;
  return careerLevels[i + 1];
}

export function maxLevel(a: CareerLevel, b: CareerLevel): CareerLevel {
  return levelMeta[a].index >= levelMeta[b].index ? a : b;
}

export function thresholdFor(level: CareerLevel, fastTrack: boolean): number {
  const base = levelMeta[level].baseThreshold;
  if (!isFinite(base)) return base;
  return fastTrack ? Math.round(base / 2) : base;
}
